import Promise from 'promise';
import { axios } from '../_helpers';
import _ from "lodash";

export const TagService = {
    getAllTags,
    getAllTagsForTopic,
    updateTag,
    insertTag,
    deleteTagInfo,
    deleteTag
};

//getAllTags will fetch all tag from master table
function getAllTags() {
    return new Promise(function (resolve, reject) {
        axios.get('getAllTags').then((res) => {
            if (res.isSuccess) {
                resolve(_.orderBy(res.data, [tag => tag.name.toLowerCase()], ['asc']));
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};

//getAllTagsForTopic will fetch all tag for topic
function getAllTagsForTopic(topicId) {
    return new Promise(function (resolve, reject) {
        axios.get('getAllTagsForTopic?topicId='+topicId).then((res) => {
            if (res.isSuccess) {
                resolve(_.orderBy(res.data, [tag => tag.name.toLowerCase()], ['asc']));
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};

//updateTag will update tag
function updateTag(userId,tagId,tagName) {
    return new Promise(function (resolve, reject) {
        axios.post('updateTag',{userId,tagId,name:tagName}).then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};

//insertTag will create new tag
function insertTag(userId,tagName) {
    return new Promise(function (resolve, reject) {
        axios.post('insertTag',{userId,tagId:0,name:tagName}).then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};

//deleteTagInfo will check whether tag is mapped to any videos
function deleteTagInfo(tagId) {
    return new Promise(function (resolve, reject) {
        axios.get('deleteTagInfo?tagId='+tagId).then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};

//deleteTag will delete tag
function deleteTag(userId,tagId) {
    return new Promise(function (resolve, reject) {
        axios.post('deleteTag',{userId,tagId}).then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};



// WEBPACK FOOTER //
// ./src/_services/tag.service.js